import { Slugs } from 'common/urls/Slugs';
import { isEmpty, noop } from 'lodash';
import React, { useMemo } from 'react';
import { Card } from 'src/shared/design-system/Avatar';
import { getTopKCuisines } from 'src/shared/design-system/DishFirstCard/utils';
import { Delimiter } from 'src/shared/design-system/Utilities/TextReplace';
import { ConsumerRoutes } from 'src/shared/Routes';
import { getSluggedPath } from 'src/shared/utils/RouteUtilities';
import { FOLLOW_TEXT } from '../../consts';
import { FollowingListItemProps, FollowingListProps } from '../../types';
import { FollowingCuisineContainer, FollowingCuisineDivider, Menu, MenuLink, NoFollowTextContainer } from './styles';

export const Item: React.FC<FollowingListItemProps> = (props) => {
  const { cuisineCategories, id, imageUrl, menuContent, publicName } = props;
  const menuUrl = id
    ? getSluggedPath(ConsumerRoutes.CONSUMER_ORDER_ONE_TIME, [{ slug: Slugs.ID, value: id ?? '' }])
    : null;

  return (
    <Card
      header={publicName}
      subHeader={
        <FollowingCuisineContainer>
          {cuisineCategories && !isEmpty(cuisineCategories) && getTopKCuisines({ cuisineCategories, k: 1 })}
          {cuisineCategories && !isEmpty(cuisineCategories) && menuUrl && <FollowingCuisineDivider />}
          {menuUrl && <MenuLink to={menuUrl}>{FOLLOW_TEXT.MENU.VIEW}</MenuLink>}
        </FollowingCuisineContainer>
      }
      imageUrl={imageUrl}
      menuContent={menuContent}
      showShadow={false}
    />
  );
};

export const FollowingListComponent: React.FC<FollowingListProps> = (props) => {
  const { children, following = [], isLoading, onClickMessage = noop, onClickUnfollow = noop } = props;
  const list = useMemo(
    () =>
      following?.map((shef, index) => (
        <Item
          key={`${index}-${shef?.id}`}
          {...shef}
          menuContent={
            <Menu
              items={[
                {
                  label: FOLLOW_TEXT.MENU.MESSAGE.replace(Delimiter, shef?.publicName ?? ''),
                  onClick: () => {
                    if (shef) {
                      onClickMessage(shef);
                    }
                  },
                },
                {
                  label: FOLLOW_TEXT.MENU.UNFOLLOW,
                  onClick: () => {
                    if (shef) {
                      onClickUnfollow(shef);
                    }
                  },
                },
              ]}
            />
          }
        />
      )),
    [following, onClickMessage, onClickUnfollow]
  );

  return (
    <div>
      {following?.length ? (
        list
      ) : (
        <>
          {!isLoading && (
            <>
              <NoFollowTextContainer>
                <div>{FOLLOW_TEXT.FOLLOWING.NONE_MESSAGE.HEADER}</div>
                <div>{FOLLOW_TEXT.FOLLOWING.NONE_MESSAGE.TEXT}</div>
              </NoFollowTextContainer>
            </>
          )}
        </>
      )}
      {children}
    </div>
  );
};

// eslint-disable-next-line functional/immutable-data -- Assigning item component
export const FollowingList = Object.assign(FollowingListComponent, { Item });
